import config from 'config/config';
import { getCountryNameByCode } from 'modules/utils';

const ENV_VALUE = config.paypalAllowedWithdrawRequestCountryCodes ?? '';

export const PAYPAL_CONFIG = {
  isInternationalWithdrawEnabled: ENV_VALUE === 'off',
  withdrawAllowedCountryCodes: ENV_VALUE.split(',') as string[],
  withdrawAllowedCountryNames: ENV_VALUE.split(',').map(getCountryNameByCode).join(', ') as string,
};
